import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["listing", "onOk"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppContext } from "../DixuApp/DixuApp";
import DixuButton from "../DixuButton/DixuButton";
import DixuDatePicker from "../DixuDatePicker/DixuDatePicker";
import DixuForm from "../DixuForm/DixuForm";
import DixuInput from "../DixuInput/DixuInput";
import DixuModal from "../DixuModal/DixuModal";
import DixuNotification from "../DixuNotification/DixuNotification";
import DixuRadio from "../DixuRadio/DixuRadio";
import DixuText from "../DixuText/DixuText";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { getErrorDescription, reservePrivatePresentation } from "../../services/ApiService";
import { PRESENTATION_TYPE } from "../../utils/DixuConstants";
import { isRealtorListing } from "../../utils/DixuListingUtils";
const DixuReservePresentationModal = _ref => {
  let {
      listing,
      onOk
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    0: availableTimes,
    1: setAvailableTimes
  } = useState();
  const {
    t
  } = useTranslation(['common', 'listing']);
  const [form] = DixuForm.useForm();
  const {
    user
  } = useContext(AppContext);
  const {
    name,
    email
  } = user || {};
  const {
    presentations
  } = listing || {};
  const realtorSelling = isRealtorListing(listing);
  const info = realtorSelling ? t('listing:MessageForm.DetailsSentToRealtorAutomatically') : t('listing:MessageForm.DetailsSentToSellerAutomatically');
  const updateAvailableTimeSlots = selectedDate => {
    if (selectedDate) {
      const formattedSelectedDate = selectedDate.format('DD.MM.YYYY');
      const reservationSlots = presentations?.filter(presentation => presentation.type === PRESENTATION_TYPE.AVAILABLE_SLOT).map(slot => _objectSpread(_objectSpread({}, slot), {}, {
        date: moment(slot.date).format('DD.MM.YYYY')
      })).filter(slot => slot.date === formattedSelectedDate);
      setAvailableTimes(reservationSlots);
      form.setFieldsValue({
        selectedSlot: null
      });
    }
  };
  const disabledDate = (date, mode) => {
    if (mode === 'date') {
      const reservationSlots = presentations?.filter(presentation => presentation.type === PRESENTATION_TYPE.AVAILABLE_SLOT).map(slot => moment(slot.date).format('DD.MM.YYYY'));
      return !reservationSlots?.includes(date.format('DD.MM.YYYY'));
    }
    return false;
  };
  const [submitForm, isSubmittingForm] = useIsLoading(async values => {
    try {
      const {
        selectedSlot
      } = values;
      await reservePrivatePresentation({
        selectedSlot
      });
      DixuNotification.open({
        message: t('listing:CreatePresentation:PresentationCreated')
      });
      onOk?.();
    } catch (error) {
      DixuNotification.error({
        message: 'Asuntonäyttelyn ajanvaraaminen epäonnistui',
        description: getErrorDescription(error)
      });
    }
  });
  const footer = /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    htmlType: "submit",
    block: true,
    loading: isSubmittingForm,
    form: "reserve-presentation"
  }, "Ehdota aikaa yksityisesittelylle");
  const initialValues = {
    name,
    email
  };
  useEffect(() => {
    updateAvailableTimeSlots();
  }, []);
  return /*#__PURE__*/React.createElement(DixuModal, _objectSpread(_objectSpread({}, rest), {}, {
    footer,
    title: t('listing:PrivatePresentation.ReservePrivatePresentation'),
    width: 582,
    loading: isSubmittingForm
  }), /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "reserve-presentation",
    initialValues: initialValues,
    onFinish: submitForm
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "name",
    label: t('common:Name'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, null)), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "email",
    label: t('common:Email'),
    rules: [{
      required: true,
      type: 'email'
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "email"
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "tel",
    label: t('common:Phone'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "tel"
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "message",
    label: t('listing:PrivatePresentation.YourMessage'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput.TextArea, {
    autoSize: {
      minRows: 4
    }
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "date",
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuDatePicker, {
    disabledDate: disabledDate,
    staticOpen: true,
    block: true,
    onChange: updateAvailableTimeSlots
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "selectedSlot",
    rules: [{
      required: true
    }],
    shouldUpdate: "date",
    visible: () => !!availableTimes?.length
  }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
    columnCount: "3",
    columnWidth: "175"
  }, availableTimes?.map(timeBlock => /*#__PURE__*/React.createElement(DixuRadio, {
    key: timeBlock.id,
    value: timeBlock.id
  }, "Klo ", timeBlock.startTime, " - ", timeBlock.endTime)))), /*#__PURE__*/React.createElement(DixuText, {
    size: "2",
    color: "2-9",
    block: true,
    className: "m-t-32 m-b-32"
  }, !availableTimes?.length && /*#__PURE__*/React.createElement(React.Fragment, null, t('listing:PrivatePresentation.SelectPresentationDateFromCalendar'))), /*#__PURE__*/React.createElement(DixuText, {
    size: "2",
    color: "2-9",
    block: true
  }, info)));
};
export default DixuReservePresentationModal;